import React from "react";
import styled from "styled-components";
import WaveformDisplay from "./WaveformDisplay";
import { MultiKeyInstrument } from "../utils/sampleUtils";
import ADSRControls from "./ADSRControls";

interface SampleSectionProps {
  currentInstrument: MultiKeyInstrument;
  waveformData: number[];
  sampleDuration?: number;
  onInstrumentChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  onPreviousInstrument?: () => void;
  onNextInstrument?: () => void;
  onShuffle?: () => void;
  onPlay?: () => void;
  onExport?: () => void;
}

const SampleSection: React.FC<SampleSectionProps> = ({
  currentInstrument,
  waveformData,
  sampleDuration = 1.0,
  onInstrumentChange,
  onPreviousInstrument,
  onNextInstrument,
  onShuffle,
}) => {
  return (
    <SampleSectionContainer id="sample-section">
      <ADSRControls />
      <WaveformDisplay
        currentInstrument={currentInstrument}
        waveformData={waveformData}
        sampleDuration={sampleDuration}
        onInstrumentChange={onInstrumentChange}
        onPreviousInstrument={onPreviousInstrument}
        onNextInstrument={onNextInstrument}
        onShuffle={onShuffle}
      />
    </SampleSectionContainer>
  );
};

export default SampleSection;

const SampleSectionContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  align-items: flex-start;
  border-radius: 8px;
  padding: 0;
  min-width: 694px;

  @media (max-width: 640px) {
    flex-direction: column;
    margin: 10px;
    max-width: none;
  }
`;
